import type { PlanSection } from '@wegic/price-ui';
import type { StorePricingModal, StorePricingModalState } from './types';
import { create } from 'zustand';

const initialState: StorePricingModalState = {
  visible: false,
  showAnnualRetention: true,
  productList: [],
  initialPlanSection: null,
  autoUpgradeProduct: null,
};

export const usePricingModalStore = create<StorePricingModal>((set) => ({
  ...initialState,
  open: (initialSection?: PlanSection, showAnnualRetention = true) => set({
    visible: true,
    initialPlanSection: initialSection ?? null,
    showAnnualRetention,
  }),
  close: () => set({ visible: false, initialPlanSection: null, autoUpgradeProduct: null, showAnnualRetention: true }),
  setProductList: (productList) => set({ productList }),
  setInitialPlanSection: (initialPlanSection) => set({ initialPlanSection }),
  setAutoUpgradeProduct: (autoUpgradeProduct) => set({ autoUpgradeProduct }),
}));
